import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-medium leading-4",
  {
    variants: {
      variant: {
        neutral: "border-line bg-panel-raised text-muted",
        success: "border-success/35 bg-success/10 text-ink",
        warning: "border-warning/35 bg-warning/10 text-ink",
        danger: "border-danger/35 bg-danger/10 text-ink",
        info: "border-info/35 bg-info/10 text-ink",
        accent: "border-accent/35 bg-accent/10 text-accent",
      },
    },
    defaultVariants: { variant: "neutral" },
  },
);

const badgeIndicatorVariants = cva("size-1.5 shrink-0 rounded-full", {
  variants: {
    variant: {
      neutral: "bg-current",
      success: "bg-success",
      warning: "bg-warning",
      danger: "bg-danger",
      info: "bg-info",
      accent: "bg-accent",
    },
  },
  defaultVariants: { variant: "neutral" },
});

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {
  indicator?: boolean;
}

export function Badge({ className, variant, indicator = false, children, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {indicator && (
        <span
          className={badgeIndicatorVariants({ variant })}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
}
